module.exports = __webpack_public_path__ + "img/shipo-icon-mfa-lock.822a6bd6.svg";